<template>
  <div class="call-to-action-area ptb--100" :style="backgroundStyle">
    <v-container>
      <v-row class="justify-center text-center">
        <v-col cols="12" md="10" lg="8">
          <div class="call-to-action-inner">
            <h2 v-if="style.ThemeHomeCallToAction?.Titulo?.Texto" class="title" :style="titleStyle">
              {{ style.ThemeHomeCallToAction.Titulo.Texto }}
            </h2>
            <p v-if="style.ThemeHomeCallToAction?.Subtitulo?.Texto" class="subtitle" :style="subtitleStyle">
              {{ style.ThemeHomeCallToAction.Subtitulo.Texto }}
            </p>
            
            <div class="mt-8" v-if="style.ThemeHomeCallToAction?.Button?.Texto">
              <a v-if="isExternalLink" :href="style.ThemeHomeCallToAction.Button.Url" target="_blank" class="notin-btn" :style="buttonStyle">
                {{ style.ThemeHomeCallToAction.Button.Texto }}
              </a>
              <NuxtLink v-else :to="style.ThemeHomeCallToAction.Button.Url || '/'" class="notin-btn" :style="buttonStyle">
                {{ style.ThemeHomeCallToAction.Button.Texto }}
              </NuxtLink>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useStyles } from '../../store/styles';
const style = useStyles();

const backgroundStyle = computed(() => {
  const css = style.ThemeHomeCallToAction?.FondoCSS;
  if (!css) return {};
  return {
    backgroundColor: css.BackgroundColor || '#f5f8fa'
  };
});

const titleStyle = computed(() => {
  const css = style.ThemeHomeCallToAction?.Titulo?.css;
  if (!css) return {};
  return {
    color: css.Color || '#000000',
    fontFamily: css.Font || 'Montserrat',
    fontSize: css.Size || '30px',
    fontWeight: css.Weight || 700,
    textAlign: css.Align || 'center'
  };
});

const subtitleStyle = computed(() => {
  const css = style.ThemeHomeCallToAction?.Subtitulo?.css;
  if (!css) return {};
  return {
    color: css.Color || '#555555',
    fontFamily: css.Font || 'Montserrat',
    fontSize: css.Size || '18px',
    fontWeight: css.Weight || 400,
    textAlign: css.Align || 'center',
    marginTop: '15px'
  };
});

const buttonStyle = computed(() => {
  const css = style.ThemeHomeCallToAction?.Button?.css;
  if (!css) return {};
  return {
    color: css.Color || '#FFFFFF',
    backgroundColor: css.BackgroundColor || '#000000',
    fontFamily: css.Font || 'Montserrat',
    fontSize: css.Size || '16px',
    fontWeight: css.Weight || 600,
    textAlign: css.Align || 'center',
    border: css.BorderColor ? `2px solid ${css.BorderColor}` : (css.Color ? `2px solid ${css.Color}` : ''),
    padding: '12px 30px',
    borderRadius: '4px',
    display: 'inline-block',
    textDecoration: 'none',
    transition: 'all 0.3s ease'
  };
});

const isExternalLink = computed(() => {
  const url = style.ThemeHomeCallToAction?.Button?.Url;
  if (!url) return false;
  return url.startsWith('http://') || url.startsWith('https://');
});
</script>

<style scoped>
.notin-btn:hover {
  opacity: 0.9;
  transform: translateY(-2px);
}
</style>
